(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("signatureCustomization", {
        templateUrl: "app/settings/theme/signature/signatureCustomization.component.html",
        controller: ["tenantResource", "ngJcropConfig", "messageService", "Upload", "FILE_FORMATS", "$scope", "$timeout", "$uibModal", SignatureCustomizationCtrl],
        controllerAs: "vm"
    });
    function SignatureCustomizationCtrl(tenantResource, ngJcropConfig, messageService, Upload, FILE_FORMATS, $scope, $timeout, $uibModal) {
        var vm = this;
        vm.delete = deleteSignature;
        vm.jcropData = {};
        vm.model = {};
        vm.saving = false;
        vm.loading = true;
        vm.acceptedFileTypes = FILE_FORMATS.image;
        vm.acceptedFileTypesFormated = vm.acceptedFileTypes.replace(/,/g, ", "); //Adds a space after each comma for better displaying
        ngJcropConfig.signature = {};
        angular.extend(ngJcropConfig.signature, ngJcropConfig.default);
        ngJcropConfig.signature.jcrop = {
            bgColor: "#fff",
            minSize: [24, 24],
            maxSize: [600, 0],
            maxHeight: 299.9,
            boxWidth: 320,
            boxHeight: 320,
            onChange: updateCrop,
            onSelect: updateCrop
        };
        ngJcropConfig.signature.previewImgStyle = {
            display: "none"
        };
        vm.jcropData.coords = [0, 0, 0, 0, 0, 0];
        tenantResource.getSignatureCustomization(function (result) {
            vm.model = result;
            loadCropArea(result);
        });
        vm.upload = function (file) {
            vm.file = file;
            if (file) {
                file.upload = Upload.upload({
                    url: "api/tenants/signature/upload",
                    data: { file: file }
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        loadCropArea(response.data);
                        messageService.success("common.dropzone.uploadedFileMessage");
                        vm.file.progress = 0;
                    });
                }, function (response) {
                    if (response.status > 0) {
                        var error = response.data.exceptionMessage ? response.data.exceptionMessage : response.data.message;
                        messageService.error(error);
                    }
                    vm.file.progress = 0;
                }, function (evt) {
                    file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                });
            }
        };
        vm.save = function () {
            vm.saving = true;
            //vm.model.coordinates = vm.coords;
            vm.model.cropData = {
                makeWhiteTransparent: vm.model.makeWhiteTransparent,
                coordinates: vm.coords
            };
            tenantResource.cropSignature(vm.model, function (result) {
                loadCropArea(result);
                messageService.success("settings.theme.signature.save.success");
                vm.saving = false;
            }, function () {
                messageService.error("common.genericError");
                vm.saving = false;
            });
        };
        function updateCrop(coords) {
            vm.coords = coords;
            $scope.$apply();
        }
        function loadCropArea(result) {
            if (!result.originalSignatureUrl) {
                vm.loading = false;
                return;
            }
            var signatureUrl = result.originalSignatureUrl;
            if (result.cropData)
                vm.model.makeWhiteTransparent = result.cropData.makeWhiteTransparent;
            // Loading image to get the actual Width and Height
            var image = new Image();
            image.onload = function () {
                $scope.$apply(function () {
                    ngJcropConfig.signature.jcrop.trueSize = [image.naturalWidth, image.naturalHeight];
                    vm.jcropData.src = signatureUrl;
                    var cropData = result.cropData;
                    if (!cropData)
                        vm.jcropData.coords = [0, 0, image.naturalWidth, image.naturalHeight, image.naturalWidth, image.naturalHeight];
                    else
                        vm.jcropData.coords = [cropData.coordinates.x, cropData.coordinates.y, cropData.coordinates.x2, cropData.coordinates.y2, cropData.coordinates.w, cropData.coordinates.h];
                    vm.loading = false;
                });
            };
            image.onerror = function () {
                vm.loading = false;
            };
            image.src = signatureUrl;
        }
        function deleteSignature() {
            var modal = $uibModal.open({
                templateUrl: "deleteConfirmation.html",
                backdrop: false,
                animation: false,
                windowClass: "confirmation-modal"
            });
            modal.result.then(function () {
                tenantResource.deleteSignature(function () {
                    vm.jcropData = {};
                }, function () {
                    messageService.error("common.genericError");
                });
            }).catch(angular.noop);
        }
    }
}());
